const checkEmpty = (value) => value == null || value === '' || !value;
const checkNumeric = (value) => !Number.isNaN(Number(value)) && Number.isFinite(Number(value));
const checkBoolean = (value) => value === 'true' || value === 'false';

function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, key) => {
    const arrayMatch = key.match(/^(.+?)\[(\d+)\]$/);
    if (arrayMatch) {
      const [, arrayKey, index] = arrayMatch;
      return acc && Array.isArray(acc[arrayKey]) ? acc[arrayKey][Number(index)] : undefined;
    }
    return acc ? acc[key] : undefined;
  }, obj);
}

function evaluate(fieldValue, operator, value) {
  const isEmpty = checkEmpty(fieldValue);
  const isNumeric = checkNumeric(fieldValue) && checkNumeric(value);
  const isBoolean = checkBoolean(value);

  if (isBoolean) {
    value = value === 'true';
  }

  switch (operator) {
    case 'empty':
      return isEmpty;
    case 'not_empty':
      return !isEmpty;
    case 'in':
      return Array.isArray(value) ? value.includes(fieldValue) : false;
    case 'not_in':
      return Array.isArray(value) ? !value.includes(fieldValue) : false;
    case 'eq':
      return fieldValue === value;
    case 'ne':
      return fieldValue !== value;
    case '>':
      return isNumeric && Number(fieldValue) > Number(value);
    case '>=':
      return isNumeric && Number(fieldValue) >= Number(value);
    case '<':
      return isNumeric && Number(fieldValue) < Number(value);
    case '<=':
      return isNumeric && Number(fieldValue) <= Number(value);
    case '^':
      return typeof fieldValue === 'string' && fieldValue.startsWith(value);
    case '$':
      return typeof fieldValue === 'string' && fieldValue.endsWith(value);
    case '*':
      return typeof fieldValue === 'string' && fieldValue.includes(value);
    default:
      return false;
  }
}

export function evaluateConditions(obj, conditions) {
  if (!Array.isArray(conditions)
    || conditions?.length === 0
    || obj == null
  ) return true;

  if (!Array.isArray(conditions[0])) {
    const fieldValue = getNestedValue(obj, conditions[0]);
    return evaluate(fieldValue, conditions[1], conditions[2]);
  }

  return conditions.every((condition) => {
    if (Array.isArray(condition[0])) {
      return condition.some((subCondition) => {
        const fieldValue = getNestedValue(obj, subCondition[0]);
        return evaluate(fieldValue, subCondition[1], subCondition[2]);
      });
    }

    const fieldValue = getNestedValue(obj, condition[0]);
    return evaluate(fieldValue, condition[1], condition[2]);
  });
}
